import { render, staticRenderFns } from "./talentInfo.vue?vue&type=template&id=34ec02c5&scoped=true"
import script from "./talentInfo.vue?vue&type=script&lang=js"
export * from "./talentInfo.vue?vue&type=script&lang=js"
import style0 from "./talentInfo.vue?vue&type=style&index=0&id=34ec02c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ec02c5",
  null
  
)

export default component.exports